module.exports = __webpack_public_path__ + "img/incomplete.a9c406d1.svg";